// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * PacsAgGrid Styles
 * Custom styling for AG Grid in PACS study list
 */

.pacs-ag-grid-container {
  position: relative;
  width: 100%;
  background: #fff;
  border: 1px solid #e2e8f1;
  border-radius: 0.75rem;
  overflow: hidden;
}

.pacs-ag-grid-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  background: rgba(255, 255, 255, 0.7);
  z-index: 10;
}

.pacs-ag-grid {
  width: 100%;
}

/* AG Grid Theme Overrides
   Palette mirrors the legacy RIS study list: a steel-gray header bar over a
   white / pale-cyan zebra. Shared by PACS, Worklist, Orders and QC Workstation
   (Orders + QC use AgGridTable, which imports this stylesheet and the same
   .pacs-ag-grid class). */

.pacs-ag-grid.ag-theme-alpine {
  --ag-header-height: 32px;
  --ag-row-height: 40px;
  --ag-header-foreground-color: #21323F;
  --ag-header-background-color: #AEB9BF;
  --ag-odd-row-background-color: #FFFFFF;
  --ag-even-row-background-color: #D9EDF3;
  --ag-row-hover-color: #C6E5EE;
  --ag-selected-row-background-color: #B7DBE7;
  --ag-range-selection-border-color: #5C7C8A;
  --ag-border-color: #DCE3E6;
  --ag-font-size: 11px;
  --ag-font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  --ag-cell-horizontal-border: solid #E4EAEC;
  --ag-borders: solid 1px;
  --ag-border-radius: 0;
  --ag-foreground-color: #1f2430;
}

/* Remove default AG Grid borders to use custom ones */

.pacs-ag-grid.ag-theme-alpine .ag-root-wrapper {
  border: none;
  border-radius: 0;
}

/* Header styling — flat steel-gray bar with a crisp bottom rule */

.pacs-ag-grid .ag-header {
  border-bottom: 2px solid #8FA0A8;
}

.pacs-ag-grid .ag-header-cell {
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border-right: 1px solid #9DA9AF;
}

.pacs-ag-grid .ag-header-cell:hover {
  background-color: #A1ADB3;
}

.pacs-ag-grid .ag-header-cell:last-child {
  border-right: none;
}

.pacs-ag-grid .ag-header-cell-label {
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
}

/* Row styling - Alternate row colors (zebra stripes) */

.pacs-ag-grid .ag-row {
  cursor: pointer;
}

.pacs-ag-grid .ag-row-odd {
  background-color: #FFFFFF;
}

.pacs-ag-grid .ag-row-even {
  background-color: #D9EDF3;
}

.pacs-ag-grid .ag-row:hover {
  background-color: #C6E5EE !important;
}

.pacs-ag-grid .ag-row-selected {
  background-color: #B7DBE7 !important;
}

/* Emergency rows - subtle red tint across the Orders / Worklist / PACS lists.
   Replaces the old per-cell AlertOutlined icon next to the patient name.
   Applies to every row segment (center + pinned-left + pinned-right) and
   overrides the zebra / hover / selected backgrounds so the tint persists. */

.pacs-ag-grid .ag-row.pacs-emergency-row,
.pacs-ag-grid .ag-row.pacs-emergency-row.ag-row-odd,
.pacs-ag-grid .ag-row.pacs-emergency-row.ag-row-even {
  background-color: rgba(226, 75, 74, 0.34) !important;
}

.pacs-ag-grid .ag-row.pacs-emergency-row:hover {
  background-color: rgba(226, 75, 74, 0.42) !important;
}

.pacs-ag-grid .ag-row.pacs-emergency-row.ag-row-selected {
  background-color: rgba(226, 75, 74, 0.46) !important;
}

/* Stronger, darker left accent bar so emergency rows stand out at a glance. */

.pacs-ag-grid .ag-pinned-left-cols-container .ag-row.pacs-emergency-row {
  -webkit-box-shadow: inset 5px 0 0 #d32029;
          box-shadow: inset 5px 0 0 #d32029;
}

/* The red fill is strong, so force white text for readability. !important beats
   the inline text colors set by the cell renderers (blue patient-name link, gray
   referring-doctor text, etc.). Excluded so their own light backgrounds stay
   legible on the red: status pills (.ant-tag), icon chips (.anticon), and the
   modality column (its text sits on a light badge - keep its original dark text). */

.pacs-ag-grid .ag-row.pacs-emergency-row .ag-cell:not([col-id="modality"]):not([col-id="po_modality"]) {
  /* color: #ffffff !important; */
}

.pacs-ag-grid .ag-row.pacs-emergency-row .ag-cell:not([col-id="modality"]):not([col-id="po_modality"]) span:not(.ant-tag):not(.anticon) {
  /* color: #ffffff !important; */
}

/* ASAP rows - subtle amber tint, a step below the emergency red. EMERGENCY
   takes precedence in getRowClass, so a row is never both. Same approach as the
   emergency tint: overrides zebra / hover / selected so the tint persists. */

.pacs-ag-grid .ag-row.pacs-asap-row,
.pacs-ag-grid .ag-row.pacs-asap-row.ag-row-odd,
.pacs-ag-grid .ag-row.pacs-asap-row.ag-row-even {
  background-color: rgba(245, 158, 11, 0.18) !important;
}

.pacs-ag-grid .ag-row.pacs-asap-row:hover {
  background-color: rgba(245, 158, 11, 0.18) !important;
}

.pacs-ag-grid .ag-row.pacs-asap-row.ag-row-selected {
  background-color: rgba(245, 158, 11, 0.18) !important;
}

.pacs-ag-grid .ag-pinned-left-cols-container .ag-row.pacs-asap-row {
  -webkit-box-shadow: inset 4px 0 0 #f59e0b;
          box-shadow: inset 4px 0 0 #f59e0b;
}

/* Cell styling — text now wraps to a second line (then clips/ellipsis) instead
   of single-line truncation. Rows are 40px to give the second line room. */

.pacs-ag-grid .ag-cell {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 0 12px;
  line-height: 1.2;
  overflow: hidden;
  white-space: normal;
  border-right: 1px solid #E4EAEC;
  color: #1a1a1a;
}

.pacs-ag-grid .ag-cell:last-child {
  border-right: none;
}

/* Plain value cells (columns without a custom renderer) — clamp to 2 lines. */

.pacs-ag-grid .ag-cell-value {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  word-break: break-word;
  width: 100%;
}

/* Custom-renderer content wrapper — let it wrap. The PACS/Worklist renderers
   apply their own 2-line clamp on the text element; for other tables (e.g.
   Orders, which set white-space:nowrap inline on their text wrappers) this
   !important override forces wrapping. Flex cells (status, series, action
   cluster, selects) are unaffected — white-space:normal is harmless there. */

.pacs-ag-grid .ag-cell .ag-react-container {
  width: 100%;
  overflow: hidden;
  white-space: normal;
}

.pacs-ag-grid .ag-cell .ag-react-container > div {
  white-space: normal !important;
  word-break: break-word;
}

/* Cell wrapper */

.pacs-ag-grid .ag-cell-wrapper {
  overflow: hidden;
  white-space: normal;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

/* Narrow icon-only leading columns (the per-action slivers pinned left before
   Patient Name: notes / info / history / download / open-viewer / select-series
   / series-info / more) - drop the cell padding so each icon sits centered in its
   slim column. Any NEW leading icon col-id must be added here or it inherits the
   general .ag-cell 0 12px padding and gets pushed right / clipped. */

.pacs-ag-grid .ag-cell[col-id="notes_icon"],
.pacs-ag-grid .ag-cell[col-id="info_icon"],
.pacs-ag-grid .ag-cell[col-id="history_icon"],
.pacs-ag-grid .ag-cell[col-id="download_icon"],
.pacs-ag-grid .ag-cell[col-id="viewer_icon"],
.pacs-ag-grid .ag-cell[col-id="series_icon"],
.pacs-ag-grid .ag-cell[col-id="series_info_icon"],
.pacs-ag-grid .ag-cell[col-id="more_icon"] {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  padding: 0;
}

/* Reporting status column - 26px sliver (matches the action-icon columns); no
   padding so the 20px badge sits centered without clipping. */

.pacs-ag-grid .ag-cell[col-id="live_report_status"] {
  padding: 0;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

/* Checkbox column - center the checkbox */

.pacs-ag-grid .ag-cell[col-id="__checkbox__"] {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  padding: 0;
}

.pacs-ag-grid .ag-cell[col-id="__checkbox__"] .ag-cell-wrapper {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: auto;
}

.pacs-ag-grid .ag-cell[col-id="__checkbox__"] .ag-selection-checkbox {
  margin: 0;
  padding: 0;
}

/* Hide the empty cell-value span in checkbox column */

.pacs-ag-grid .ag-cell[col-id="__checkbox__"] .ag-cell-value {
  display: none;
}

/* Header checkbox centering */

.pacs-ag-grid .ag-header-cell[col-id="__checkbox__"] {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.pacs-ag-grid .ag-header-cell[col-id="__checkbox__"] .ag-header-cell-comp-wrapper {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.pacs-ag-grid .ag-header-cell[col-id="__checkbox__"] .ag-header-select-all {
  margin: 0;
}

.pacs-ag-grid .ag-checkbox-input-wrapper {
  font-size: 16px;
}

/* Pinned columns — transparent containers so the row zebra (white / pale-cyan)
   shows through the pinned sections, including the leading action-icon area, just
   like the reference. Pinned headers match the steel-gray header bar. */

.pacs-ag-grid .ag-pinned-left-cols-container,
.pacs-ag-grid .ag-pinned-right-cols-container {
  background-color: transparent;
}

.pacs-ag-grid .ag-pinned-left-header,
.pacs-ag-grid .ag-pinned-right-header {
  background-color: #AEB9BF;
}

/* Pinned column separator */

.pacs-ag-grid .ag-pinned-left-cols-container {
  border-right: 2px solid #9DA9AF;
}

.pacs-ag-grid .ag-pinned-right-cols-container {
  border-left: 2px solid #9DA9AF;
}

/* Scrollbar styling */

.pacs-ag-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar,
.pacs-ag-grid .ag-body-vertical-scroll-viewport::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.pacs-ag-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track,
.pacs-ag-grid .ag-body-vertical-scroll-viewport::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.pacs-ag-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb,
.pacs-ag-grid .ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.pacs-ag-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb:hover,
.pacs-ag-grid .ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Action buttons in cells */

.pacs-ag-grid .action-icon-button {
  padding: 4px 8px;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 4px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  color: #595959;
  font-size: 18px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 34px;
  height: 28px;
}

.pacs-ag-grid .action-icon-button:hover {
  /* Tinted hover pill matching the icon's hue (set per-icon via --ai-hover).
     The glyph keeps its own inline color, so we only theme the pill. */
  background-color: var(--ai-hover, #eef1f5);
}

.pacs-ag-grid .action-icon-button.disabled {
  /* Flat icon self-fades when disabled; wrapper only sets the cursor. */
  cursor: not-allowed;
}

.pacs-ag-grid .action-icon-button.disabled:hover {
  background-color: transparent;
}

/* Patient name column.
   The global \`.col-pat-name { margin-left: -0.1875rem }\` rule (pacs.css) was tuned
   for the old antd Table cell padding. Inside an AG Grid cell (overflow: hidden)
   that negative margin shoves the name left and clips the first glyph, so reset it
   here. PACS itself uses PatientNameCellRenderer (no .col-pat-name class) and is
   unaffected; this only corrects the migrated Orders/Worklist/QC grids. */

.pacs-ag-grid .ag-cell .col-pat-name {
  margin-left: 0 !important;
}

/* Patient name is left-aligned (not centered): force the flex cell + its inner
   content to start-align so the name hugs the left edge of the column. */

.pacs-ag-grid .ag-cell[col-id="pat_name"],
.pacs-ag-grid .ag-cell[col-id="po_pat_name"] {
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  text-align: left;
}

.pacs-ag-grid .ag-cell[col-id="pat_name"] .ag-react-container,
.pacs-ag-grid .ag-cell[col-id="po_pat_name"] .ag-react-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
}

/* Status tags */

.pacs-ag-grid .ant-tag {
  margin: 0;
  font-size: 11px;
  min-width: 58px;
  text-align: center;
}

/* Tooltip styling */

.pacs-ag-grid .ag-tooltip {
  background-color: #333;
  color: #fff;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 12px;
}

/* Loading overlay */

.pacs-ag-grid .ag-overlay-loading-wrapper {
  background-color: rgba(255, 255, 255, 0.8);
}

/* No rows overlay */

.pacs-ag-grid .ag-overlay-no-rows-wrapper {
  padding: 20px;
  color: #999;
}

/* =============================================
   Pagination Section Styling
   ============================================= */

.pacs-ag-grid-pagination {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 4px 12px;
  background: #FAFAFA;
  border-top: 1px solid #EBEBEB;
  width: 100%;
}

.pacs-ag-grid-pagination .ant-pagination {
  width: 100%;
}

.pacs-ag-grid-pagination .ant-pagination .ant-pagination-item,
.pacs-ag-grid-pagination .ant-pagination .ant-pagination-prev,
.pacs-ag-grid-pagination .ant-pagination .ant-pagination-next,
.pacs-ag-grid-pagination .ant-pagination .ant-pagination-jump-prev,
.pacs-ag-grid-pagination .ant-pagination .ant-pagination-jump-next {
  min-width: 24px;
  height: 24px;
  line-height: 22px;
  font-size: 12px;
}

.pacs-ag-grid-pagination .ant-pagination .ant-select-selector {
  height: 24px !important;
  font-size: 12px;
}

.pacs-ag-grid-pagination .ant-pagination .ant-select-selection-item {
  line-height: 22px !important;
}
`, "",{"version":3,"sources":["webpack://./components/PacsAgGrid/PacsAgGrid.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;0BAI0B;;AAC1B;EACE,wBAAwB;EACxB,qBAAqB;EACrB,qCAAqC;EACrC,qCAAqC;EACrC,sCAAsC;EACtC,uCAAuC;EACvC,6BAA6B;EAC7B,2CAA2C;EAC3C,0CAA0C;EAC1C,0BAA0B;EAC1B,oBAAoB;EACpB,oFAAoF;EACpF,0CAA0C;EAC1C,uBAAuB;EACvB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,sDAAsD;;AACtD;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,kEAAkE;;AAClE;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;AAC7B;;AAEA,uDAAuD;;AACvD;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;6EAG6E;;AAC7E;;;EAGE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA,8EAA8E;;AAC9E;EACE,yCAAiC;UAAjC,iCAAiC;AACnC;;AAEA;;;;oFAIoF;;AACpF;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;6EAE6E;;AAC7E;;;EAGE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,yCAAiC;UAAjC,iCAAiC;AACnC;;AAEA;2EAC2E;;AAC3E;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8EAA8E;;AAC9E;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;;;;6EAI6E;;AAC7E;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,iBAAiB;;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;;;;qEAIqE;;AACrE;;;;;;;;EAQE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;8DAC8D;;AAC9D;EACE,UAAU;EACV,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA,0CAA0C;;AAC1C;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA,sDAAsD;;AACtD;EACE,aAAa;AACf;;AAEA,8BAA8B;;AAC9B;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,oBAAa;EAAb,oBAAa;EAAb,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;;wEAEwE;;AACxE;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,4BAA4B;;AAC5B;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,sBAAsB;;AACtB;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,4BAA4B;;AAC5B;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,iCAAyB;EAAzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE;uEACqE;EACrE,0CAA0C;AAC5C;;AAEA;EACE,sEAAsE;EACtE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;;0EAK0E;;AAC1E;EACE,yBAAyB;AAC3B;;AAEA;yEACyE;;AACzE;;EAEE,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;EAC3B,gBAAgB;AAClB;;AACA;;EAEE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;AAC7B;;AAEA,gBAAgB;;AAChB;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,oBAAoB;;AACpB;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,oBAAoB;;AACpB;EACE,0CAA0C;AAC5C;;AAEA,oBAAoB;;AACpB;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;kDAEkD;;AAClD;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;EAKE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["/**\r\n * PacsAgGrid Styles\r\n * Custom styling for AG Grid in PACS study list\r\n */\r\n\r\n.pacs-ag-grid-container {\r\n  position: relative;\r\n  width: 100%;\r\n  background: #fff;\r\n  border: 1px solid #e2e8f1;\r\n  border-radius: 0.75rem;\r\n  overflow: hidden;\r\n}\r\n\r\n.pacs-ag-grid-loading {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(255, 255, 255, 0.7);\r\n  z-index: 10;\r\n}\r\n\r\n.pacs-ag-grid {\r\n  width: 100%;\r\n}\r\n\r\n/* AG Grid Theme Overrides\r\n   Palette mirrors the legacy RIS study list: a steel-gray header bar over a\r\n   white / pale-cyan zebra. Shared by PACS, Worklist, Orders and QC Workstation\r\n   (Orders + QC use AgGridTable, which imports this stylesheet and the same\r\n   .pacs-ag-grid class). */\r\n.pacs-ag-grid.ag-theme-alpine {\r\n  --ag-header-height: 32px;\r\n  --ag-row-height: 40px;\r\n  --ag-header-foreground-color: #21323F;\r\n  --ag-header-background-color: #AEB9BF;\r\n  --ag-odd-row-background-color: #FFFFFF;\r\n  --ag-even-row-background-color: #D9EDF3;\r\n  --ag-row-hover-color: #C6E5EE;\r\n  --ag-selected-row-background-color: #B7DBE7;\r\n  --ag-range-selection-border-color: #5C7C8A;\r\n  --ag-border-color: #DCE3E6;\r\n  --ag-font-size: 11px;\r\n  --ag-font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\r\n  --ag-cell-horizontal-border: solid #E4EAEC;\r\n  --ag-borders: solid 1px;\r\n  --ag-border-radius: 0;\r\n  --ag-foreground-color: #1f2430;\r\n}\r\n\r\n/* Remove default AG Grid borders to use custom ones */\r\n.pacs-ag-grid.ag-theme-alpine .ag-root-wrapper {\r\n  border: none;\r\n  border-radius: 0;\r\n}\r\n\r\n/* Header styling — flat steel-gray bar with a crisp bottom rule */\r\n.pacs-ag-grid .ag-header {\r\n  border-bottom: 2px solid #8FA0A8;\r\n}\r\n\r\n.pacs-ag-grid .ag-header-cell {\r\n  font-weight: 600;\r\n  font-size: 11px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.4px;\r\n  border-right: 1px solid #9DA9AF;\r\n}\r\n\r\n.pacs-ag-grid .ag-header-cell:hover {\r\n  background-color: #A1ADB3;\r\n}\r\n\r\n.pacs-ag-grid .ag-header-cell:last-child {\r\n  border-right: none;\r\n}\r\n\r\n.pacs-ag-grid .ag-header-cell-label {\r\n  justify-content: flex-start;\r\n}\r\n\r\n/* Row styling - Alternate row colors (zebra stripes) */\r\n.pacs-ag-grid .ag-row {\r\n  cursor: pointer;\r\n}\r\n\r\n.pacs-ag-grid .ag-row-odd {\r\n  background-color: #FFFFFF;\r\n}\r\n\r\n.pacs-ag-grid .ag-row-even {\r\n  background-color: #D9EDF3;\r\n}\r\n\r\n.pacs-ag-grid .ag-row:hover {\r\n  background-color: #C6E5EE !important;\r\n}\r\n\r\n.pacs-ag-grid .ag-row-selected {\r\n  background-color: #B7DBE7 !important;\r\n}\r\n\r\n/* Emergency rows - subtle red tint across the Orders / Worklist / PACS lists.\r\n   Replaces the old per-cell AlertOutlined icon next to the patient name.\r\n   Applies to every row segment (center + pinned-left + pinned-right) and\r\n   overrides the zebra / hover / selected backgrounds so the tint persists. */\r\n.pacs-ag-grid .ag-row.pacs-emergency-row,\r\n.pacs-ag-grid .ag-row.pacs-emergency-row.ag-row-odd,\r\n.pacs-ag-grid .ag-row.pacs-emergency-row.ag-row-even {\r\n  background-color: rgba(226, 75, 74, 0.34) !important;\r\n}\r\n\r\n.pacs-ag-grid .ag-row.pacs-emergency-row:hover {\r\n  background-color: rgba(226, 75, 74, 0.42) !important;\r\n}\r\n\r\n.pacs-ag-grid .ag-row.pacs-emergency-row.ag-row-selected {\r\n  background-color: rgba(226, 75, 74, 0.46) !important;\r\n}\r\n\r\n/* Stronger, darker left accent bar so emergency rows stand out at a glance. */\r\n.pacs-ag-grid .ag-pinned-left-cols-container .ag-row.pacs-emergency-row {\r\n  box-shadow: inset 5px 0 0 #d32029;\r\n}\r\n\r\n/* The red fill is strong, so force white text for readability. !important beats\r\n   the inline text colors set by the cell renderers (blue patient-name link, gray\r\n   referring-doctor text, etc.). Excluded so their own light backgrounds stay\r\n   legible on the red: status pills (.ant-tag), icon chips (.anticon), and the\r\n   modality column (its text sits on a light badge - keep its original dark text). */\r\n.pacs-ag-grid .ag-row.pacs-emergency-row .ag-cell:not([col-id=\"modality\"]):not([col-id=\"po_modality\"]) {\r\n  /* color: #ffffff !important; */\r\n}\r\n\r\n.pacs-ag-grid .ag-row.pacs-emergency-row .ag-cell:not([col-id=\"modality\"]):not([col-id=\"po_modality\"]) span:not(.ant-tag):not(.anticon) {\r\n  /* color: #ffffff !important; */\r\n}\r\n\r\n/* ASAP rows - subtle amber tint, a step below the emergency red. EMERGENCY\r\n   takes precedence in getRowClass, so a row is never both. Same approach as the\r\n   emergency tint: overrides zebra / hover / selected so the tint persists. */\r\n.pacs-ag-grid .ag-row.pacs-asap-row,\r\n.pacs-ag-grid .ag-row.pacs-asap-row.ag-row-odd,\r\n.pacs-ag-grid .ag-row.pacs-asap-row.ag-row-even {\r\n  background-color: rgba(245, 158, 11, 0.18) !important;\r\n}\r\n\r\n.pacs-ag-grid .ag-row.pacs-asap-row:hover {\r\n  background-color: rgba(245, 158, 11, 0.18) !important;\r\n}\r\n\r\n.pacs-ag-grid .ag-row.pacs-asap-row.ag-row-selected {\r\n  background-color: rgba(245, 158, 11, 0.18) !important;\r\n}\r\n\r\n.pacs-ag-grid .ag-pinned-left-cols-container .ag-row.pacs-asap-row {\r\n  box-shadow: inset 4px 0 0 #f59e0b;\r\n}\r\n\r\n/* Cell styling — text now wraps to a second line (then clips/ellipsis) instead\r\n   of single-line truncation. Rows are 40px to give the second line room. */\r\n.pacs-ag-grid .ag-cell {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 12px;\r\n  line-height: 1.2;\r\n  overflow: hidden;\r\n  white-space: normal;\r\n  border-right: 1px solid #E4EAEC;\r\n  color: #1a1a1a;\r\n}\r\n\r\n.pacs-ag-grid .ag-cell:last-child {\r\n  border-right: none;\r\n}\r\n\r\n/* Plain value cells (columns without a custom renderer) — clamp to 2 lines. */\r\n.pacs-ag-grid .ag-cell-value {\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  white-space: normal;\r\n  word-break: break-word;\r\n  width: 100%;\r\n}\r\n\r\n/* Custom-renderer content wrapper — let it wrap. The PACS/Worklist renderers\r\n   apply their own 2-line clamp on the text element; for other tables (e.g.\r\n   Orders, which set white-space:nowrap inline on their text wrappers) this\r\n   !important override forces wrapping. Flex cells (status, series, action\r\n   cluster, selects) are unaffected — white-space:normal is harmless there. */\r\n.pacs-ag-grid .ag-cell .ag-react-container {\r\n  width: 100%;\r\n  overflow: hidden;\r\n  white-space: normal;\r\n}\r\n\r\n.pacs-ag-grid .ag-cell .ag-react-container > div {\r\n  white-space: normal !important;\r\n  word-break: break-word;\r\n}\r\n\r\n/* Cell wrapper */\r\n.pacs-ag-grid .ag-cell-wrapper {\r\n  overflow: hidden;\r\n  white-space: normal;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* Narrow icon-only leading columns (the per-action slivers pinned left before\r\n   Patient Name: notes / info / history / download / open-viewer / select-series\r\n   / series-info / more) - drop the cell padding so each icon sits centered in its\r\n   slim column. Any NEW leading icon col-id must be added here or it inherits the\r\n   general .ag-cell 0 12px padding and gets pushed right / clipped. */\r\n.pacs-ag-grid .ag-cell[col-id=\"notes_icon\"],\r\n.pacs-ag-grid .ag-cell[col-id=\"info_icon\"],\r\n.pacs-ag-grid .ag-cell[col-id=\"history_icon\"],\r\n.pacs-ag-grid .ag-cell[col-id=\"download_icon\"],\r\n.pacs-ag-grid .ag-cell[col-id=\"viewer_icon\"],\r\n.pacs-ag-grid .ag-cell[col-id=\"series_icon\"],\r\n.pacs-ag-grid .ag-cell[col-id=\"series_info_icon\"],\r\n.pacs-ag-grid .ag-cell[col-id=\"more_icon\"] {\r\n  justify-content: center;\r\n  padding: 0;\r\n}\r\n\r\n/* Reporting status column - 26px sliver (matches the action-icon columns); no\r\n   padding so the 20px badge sits centered without clipping. */\r\n.pacs-ag-grid .ag-cell[col-id=\"live_report_status\"] {\r\n  padding: 0;\r\n  justify-content: center;\r\n}\r\n\r\n/* Checkbox column - center the checkbox */\r\n.pacs-ag-grid .ag-cell[col-id=\"__checkbox__\"] {\r\n  justify-content: center;\r\n  padding: 0;\r\n}\r\n\r\n.pacs-ag-grid .ag-cell[col-id=\"__checkbox__\"] .ag-cell-wrapper {\r\n  justify-content: center;\r\n  display: flex;\r\n  width: auto;\r\n}\r\n\r\n.pacs-ag-grid .ag-cell[col-id=\"__checkbox__\"] .ag-selection-checkbox {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/* Hide the empty cell-value span in checkbox column */\r\n.pacs-ag-grid .ag-cell[col-id=\"__checkbox__\"] .ag-cell-value {\r\n  display: none;\r\n}\r\n\r\n/* Header checkbox centering */\r\n.pacs-ag-grid .ag-header-cell[col-id=\"__checkbox__\"] {\r\n  justify-content: center;\r\n}\r\n\r\n.pacs-ag-grid .ag-header-cell[col-id=\"__checkbox__\"] .ag-header-cell-comp-wrapper {\r\n  justify-content: center;\r\n  display: flex;\r\n}\r\n\r\n.pacs-ag-grid .ag-header-cell[col-id=\"__checkbox__\"] .ag-header-select-all {\r\n  margin: 0;\r\n}\r\n\r\n.pacs-ag-grid .ag-checkbox-input-wrapper {\r\n  font-size: 16px;\r\n}\r\n\r\n/* Pinned columns — transparent containers so the row zebra (white / pale-cyan)\r\n   shows through the pinned sections, including the leading action-icon area, just\r\n   like the reference. Pinned headers match the steel-gray header bar. */\r\n.pacs-ag-grid .ag-pinned-left-cols-container,\r\n.pacs-ag-grid .ag-pinned-right-cols-container {\r\n  background-color: transparent;\r\n}\r\n\r\n.pacs-ag-grid .ag-pinned-left-header,\r\n.pacs-ag-grid .ag-pinned-right-header {\r\n  background-color: #AEB9BF;\r\n}\r\n\r\n/* Pinned column separator */\r\n.pacs-ag-grid .ag-pinned-left-cols-container {\r\n  border-right: 2px solid #9DA9AF;\r\n}\r\n\r\n.pacs-ag-grid .ag-pinned-right-cols-container {\r\n  border-left: 2px solid #9DA9AF;\r\n}\r\n\r\n/* Scrollbar styling */\r\n.pacs-ag-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar,\r\n.pacs-ag-grid .ag-body-vertical-scroll-viewport::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n.pacs-ag-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track,\r\n.pacs-ag-grid .ag-body-vertical-scroll-viewport::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n.pacs-ag-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb,\r\n.pacs-ag-grid .ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb {\r\n  background: #c1c1c1;\r\n  border-radius: 4px;\r\n}\r\n\r\n.pacs-ag-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb:hover,\r\n.pacs-ag-grid .ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb:hover {\r\n  background: #a8a8a8;\r\n}\r\n\r\n/* Action buttons in cells */\r\n.pacs-ag-grid .action-icon-button {\r\n  padding: 4px 8px;\r\n  margin: 0;\r\n  border: none;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  transition: all 0.2s ease;\r\n  color: #595959;\r\n  font-size: 18px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 34px;\r\n  height: 28px;\r\n}\r\n\r\n.pacs-ag-grid .action-icon-button:hover {\r\n  /* Tinted hover pill matching the icon's hue (set per-icon via --ai-hover).\r\n     The glyph keeps its own inline color, so we only theme the pill. */\r\n  background-color: var(--ai-hover, #eef1f5);\r\n}\r\n\r\n.pacs-ag-grid .action-icon-button.disabled {\r\n  /* Flat icon self-fades when disabled; wrapper only sets the cursor. */\r\n  cursor: not-allowed;\r\n}\r\n\r\n.pacs-ag-grid .action-icon-button.disabled:hover {\r\n  background-color: transparent;\r\n}\r\n\r\n/* Patient name column.\r\n   The global `.col-pat-name { margin-left: -0.1875rem }` rule (pacs.css) was tuned\r\n   for the old antd Table cell padding. Inside an AG Grid cell (overflow: hidden)\r\n   that negative margin shoves the name left and clips the first glyph, so reset it\r\n   here. PACS itself uses PatientNameCellRenderer (no .col-pat-name class) and is\r\n   unaffected; this only corrects the migrated Orders/Worklist/QC grids. */\r\n.pacs-ag-grid .ag-cell .col-pat-name {\r\n  margin-left: 0 !important;\r\n}\r\n\r\n/* Patient name is left-aligned (not centered): force the flex cell + its inner\r\n   content to start-align so the name hugs the left edge of the column. */\r\n.pacs-ag-grid .ag-cell[col-id=\"pat_name\"],\r\n.pacs-ag-grid .ag-cell[col-id=\"po_pat_name\"] {\r\n  justify-content: flex-start;\r\n  text-align: left;\r\n}\r\n.pacs-ag-grid .ag-cell[col-id=\"pat_name\"] .ag-react-container,\r\n.pacs-ag-grid .ag-cell[col-id=\"po_pat_name\"] .ag-react-container {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n}\r\n\r\n/* Status tags */\r\n.pacs-ag-grid .ant-tag {\r\n  margin: 0;\r\n  font-size: 11px;\r\n  min-width: 58px;\r\n  text-align: center;\r\n}\r\n\r\n/* Tooltip styling */\r\n.pacs-ag-grid .ag-tooltip {\r\n  background-color: #333;\r\n  color: #fff;\r\n  border-radius: 4px;\r\n  padding: 6px 10px;\r\n  font-size: 12px;\r\n}\r\n\r\n/* Loading overlay */\r\n.pacs-ag-grid .ag-overlay-loading-wrapper {\r\n  background-color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n/* No rows overlay */\r\n.pacs-ag-grid .ag-overlay-no-rows-wrapper {\r\n  padding: 20px;\r\n  color: #999;\r\n}\r\n\r\n/* =============================================\r\n   Pagination Section Styling\r\n   ============================================= */\r\n.pacs-ag-grid-pagination {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 4px 12px;\r\n  background: #FAFAFA;\r\n  border-top: 1px solid #EBEBEB;\r\n  width: 100%;\r\n}\r\n\r\n.pacs-ag-grid-pagination .ant-pagination {\r\n  width: 100%;\r\n}\r\n\r\n.pacs-ag-grid-pagination .ant-pagination .ant-pagination-item,\r\n.pacs-ag-grid-pagination .ant-pagination .ant-pagination-prev,\r\n.pacs-ag-grid-pagination .ant-pagination .ant-pagination-next,\r\n.pacs-ag-grid-pagination .ant-pagination .ant-pagination-jump-prev,\r\n.pacs-ag-grid-pagination .ant-pagination .ant-pagination-jump-next {\r\n  min-width: 24px;\r\n  height: 24px;\r\n  line-height: 22px;\r\n  font-size: 12px;\r\n}\r\n\r\n.pacs-ag-grid-pagination .ant-pagination .ant-select-selector {\r\n  height: 24px !important;\r\n  font-size: 12px;\r\n}\r\n\r\n.pacs-ag-grid-pagination .ant-pagination .ant-select-selection-item {\r\n  line-height: 22px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
